import React from "react";
import CustomSpinner from "../Spinner";

function DataLoader({ isLoading, error, children }) {
  if (isLoading) {
    return <CustomSpinner />;
  }

  if (error) {
    return <div style={{ color: "red" }}>{error}</div>;
  }

  return <>{children}</>;
}

export default DataLoader;
